import { render, staticRenderFns } from "./RelationFinder.vue?vue&type=template&id=83fced88&scoped=true&"
import script from "./RelationFinder.vue?vue&type=script&lang=js&"
export * from "./RelationFinder.vue?vue&type=script&lang=js&"
import style0 from "./RelationFinder.vue?vue&type=style&index=0&id=83fced88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fced88",
  null
  
)

export default component.exports